import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-card-info-contato',
  standalone: true,
  imports: [
    CurrencyPipe
  ],
  templateUrl: './card-info-contato.component.html',
  styleUrl: './card-info-contato.component.css'
})
export class CardInfoContatoComponent implements OnChanges {
  @Input() quantidade?: number;
  @Input() titulo?: string;
  @Input() backgroundColor?: string;
  @Input() fontSizeInfo = 'var(--display-metrica)';
  @Input() colorText = 'white';
  @Input() isPorcentagem = false;
  @Input() isMoeda = false;
  @Input() moeda: 'BRL' | 'USD' | 'EUR' = 'USD';

  atualizouAgora = false;

  ngOnChanges(changes: SimpleChanges): void {
    const mudancaQuantidade = changes['quantidade'];
    if (!mudancaQuantidade || mudancaQuantidade.firstChange) return;
    if (mudancaQuantidade.previousValue === mudancaQuantidade.currentValue) return;

    this.atualizouAgora = true;
    setTimeout(() => this.atualizouAgora = false, 700);
  }
}
